import { IRootState } from '../../../store'
import { ILoginState } from '../store/login.types'

export const getLoginSelector = (state: IRootState): ILoginState => state.login
